import React from 'react';
import {BsGithub} from 'react-icons/bs';
import {FaBloggerB, FaFacebook} from 'react-icons/fa';
import { AiFillLinkedin } from 'react-icons/ai';
import { SiCodeforces, SiHackerrank } from 'react-icons/si';

const SocialMedia = () => {
    return (
        <div className='app__social'>
            <div>
            <a title='Github' href="https://github.com/pinky-banik" target="_blank"><BsGithub title='Github'/></a>
            </div>
            <div>
            <a title='Linkedin' href="https://www.linkedin.com/in/pinkybanik/"  target="_blank"><AiFillLinkedin title='Linkedin'/></a>
            </div>
            <div>
            <a title='Blogger' href="https://pinky-banik.blogspot.com/" target="_blank"><FaBloggerB /></a>
            </div>
            <div>
            <a title='Codeforces' href="https://codeforces.com/profile/pinky.banik/"  target="_blank"><SiCodeforces title='Codeforces'/></a>
            </div>
            <div>
            <a title='Hacker Rank' href="https://www.hackerrank.com/pinky_banik"  target="_blank"><SiHackerrank title='Hacker Rank'/></a>
            </div>
        </div>
    );
};

export default SocialMedia;